module.exports = __webpack_public_path__ + "img/factsCheckHero.41e6ca32.svg";